/* 12039580: Fly to Cart File */

(function () {
  let pendingSource = null;

  function getStartRect(el) {
    const container =
      el.closest('.card-wrapper') ||
      el.closest('.quick-add-modal__content') ||
      el.closest('.product') ||
      el.closest('product-info') ||
      el.closest('.shopify-section');
    const img = container ? container.querySelector('img') : null;
    return { img, el, rect: (img || el).getBoundingClientRect() };
  }

  // Real "Add to cart" submissions only. Buttons that just OPEN the "choose
  // options" popup live inside <modal-opener> and are ignored here — the
  // real add button appears once you're inside that popup.
  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest('button[name="add"]');
      if (!btn || btn.closest('modal-opener')) return;
      pendingSource = getStartRect(btn);
    },
    true
  );

  // Bulk quantity-stepper add flow (no-variant products under "Quick add: bulk")
  // — there's no submit button, typing/changing the quantity triggers the add.
  document.addEventListener(
    'change',
    function (e) {
      if (!e.target.matches('quantity-input input')) return;
      pendingSource = getStartRect(e.target);
    },
    true
  );

  // ---------- Flying product image, curved path ----------
  function flyToCart(source) {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (!cartIcon || !source) return;

    const endRect = cartIcon.getBoundingClientRect();
    const startRect = source.rect;

    const startX = startRect.left + startRect.width / 2;
    const startY = startRect.top + startRect.height / 2;
    const endX = endRect.left + endRect.width / 2;
    const endY = endRect.top + endRect.height / 2;
    const controlX = (startX + endX) / 2;
    const controlY = Math.min(startY, endY) - 140; // arcs the flight upward

    const clone = document.createElement(source.img ? 'img' : 'div');
    if (source.img) {
      clone.src = source.img.currentSrc || source.img.src;
    } else {
      clone.style.background = 'var(--color-foreground, #000)';
    }
    clone.className = 'fly-to-cart-clone';
    document.body.appendChild(clone);

    const duration = 700;
    const startTime = performance.now();
    //const size0 = 64;
    //const size1 = 14;


    // Start at the image's actual on-page size, then shrink to a small dot
// by the time it reaches the cart icon.
const size0 = Math.max(startRect.width, startRect.height) || 64; // fallback if rect is 0
const size1 = 14;

    function frame(now) {
      const t = Math.min((now - startTime) / duration, 1);
      const ease = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; // ease-in-out
      const x = (1 - ease) * (1 - ease) * startX + 2 * (1 - ease) * ease * controlX + ease * ease * endX;
      const y = (1 - ease) * (1 - ease) * startY + 2 * (1 - ease) * ease * controlY + ease * ease * endY;
      const size = size0 + (size1 - size0) * ease;
      const opacity = t < 0.75 ? 1 : 1 - (t - 0.75) / 0.25;

      clone.style.width = size + 'px';
      clone.style.height = size + 'px';
      clone.style.left = x - size / 2 + 'px';
      clone.style.top = y - size / 2 + 'px';
      clone.style.opacity = opacity;
      clone.style.transform = 'rotate(' + ease * 25 + 'deg)';

      if (t < 1) {
        requestAnimationFrame(frame);
      } else {
        clone.remove();
        bumpCartIcon(cartIcon);
      }
    }
    requestAnimationFrame(frame);
  }

  // ---------- Cart icon reaction: bump + pulse ring + count pop ----------
  function bumpCartIcon(cartIcon) {
    cartIcon.classList.remove('bump');
    void cartIcon.offsetWidth; // restart animation if it's still running
    cartIcon.classList.add('bump');
    setTimeout(() => cartIcon.classList.remove('bump'), 500);

    const ring = document.createElement('span');
    ring.className = 'cart-icon-pulse-ring';
    cartIcon.appendChild(ring);
    ring.addEventListener('animationend', () => ring.remove());

    const bubble = cartIcon.querySelector('.cart-count-bubble');
    if (bubble) {
      bubble.classList.remove('pop');
      void bubble.offsetWidth;
      bubble.classList.add('pop');
    }
  }

  // Dawn publishes this event only after a successful /cart/add or /cart/update
  // call — from the product page, a single-item quick add, the "choose options"
  // popup, or the bulk quantity stepper. This is what makes everything fire at
  // the right moment in every case.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      flyToCart(pendingSource);
      pendingSource = null;
    });
  }
})();